import React from 'react';

export default function Footer() {
   return (
      <React.Fragment>
         <footer className='has-background-blue-custom'>
            Copyright &#169; 2020. Powered by Comza &#38; e-Step | Terms &#38; Privacy
         </footer>
      </React.Fragment>
   );
}
